
(function(template){
  define('vue!app/views/vue/components/packageDivComponent/reviewComponent/container',[
    "Vue",
    "helpers",
    "vuex",

  ], function (
    Vue,
    helpers,
    vuex
  ) {
    return {
      template: template,
      name: "",
      computed: _.extend(
        vuex.mapState(['ReviewScreenBookingDetails','desktopMode','activeStep','detectedChanges', 'dynamicRestErrorMessage']), {
            bookedServiceName: function(){
                return this.ReviewScreenBookingDetails.serviceName
            },
            bookings:function(){
                 return this.ReviewScreenBookingDetails.bookings
            },
            bookedPackage:function(){
                return this.ReviewScreenBookingDetails.isPackage
            },
            locationName:function(){
                var locationData = helpers.getSelectedLocation();
                return locationData.LocationName
            },
            username:function(){
              return this.ReviewScreenBookingDetails.username
            },
            reservationLabel:function () {
              if(this.ReviewScreenBookingDetails.isEditingService) return this.localStrings.stepper.body.review.updated
              else return this.localStrings.stepper.body.review.reserved
            },
            addMoreServices:function(){
              var customization = app.customization.features
              var obj = {}
              obj[this.localStrings.stepper.body.review.spa] = {url:'#/spaBooking',isEnabled:customization["spaBooking"]}

              obj[this.localStrings.stepper.body.review.golf] = {url:'#/golfBooking',isEnabled:customization["golfBooking"]}

              obj[this.localStrings.stepper.body.review.pms] =  {url:'#/roomsBooking',isEnabled:customization["pmsBooking"]}

              obj[this.localStrings.stepper.body.review.gift] = {url:'#/giftCertificates',isEnabled:customization["giftCertificates"]}

              obj[this.localStrings.stepper.body.review.ski] = {url:'#/ski',isEnabled:customization["skiBooking"]},

              obj[this.localStrings.stepper.body.review.dine] = {url:'#/dining',isEnabled:customization["diningBooking"]}

              obj[this.localStrings.stepper.body.review.club] = {url:'#/membership',isEnabled:customization["clubBooking"]}
              return obj;
            }
        }),
      components: {},
      methods: {
          bookmore:function(){
            if(!this.desktopMode) this.$store.commit('setmobileCategoryShow',true)
            this.$store.commit('setReviewScreenBookingDetails',{})//empty booking details for review screen before it set again
            this.$store.commit('setActiveStep', 0)
          },
          renderDynamicRest_reviewErrorMessage:function(){
              if(app.commonViewHelper.activeEffects.preventCheckout) {
                  var preventCheckResult = app.commonViewHelper.groupEffects(app.commonViewHelper.activeEffects.preventCheckout);
                  if(preventCheckResult.isActive){
                    this.$store.commit('setDynamicRestErrorMessage', preventCheckResult.value);
                  } else {
                    this.$store.commit('setDynamicRestErrorMessage', '');
                  } 
              } else this.$store.commit('setDynamicRestErrorMessage', '');
          },
          dispatchToSummary:function(){
            this.$store.commit('setActiveStep', 0);
            app.dispatcher.currentRoute = {0: 'summary', 1: 'show', 2: ''};
            app.dispatcher.redirect('summary');
          }
      },
      watch:{

      },
      mounted:function(){
        var vm = this;
        if(!this.desktopMode) window.scrollTo({top: 0, behavior: 'smooth'});
        helpers.updateCalender();
        if(app.customization.dynamicRestrictions){
          var defer = $.Deferred(); 
          defer
            .then(function(){
                $.when(app.models.systemModel.getData('folioBookings', {}))
                  .done(function(res){
                    app.commonViewHelper.evalCriteria();
                    vm.renderDynamicRest_reviewErrorMessage();
                  })
            })
          defer.resolve();
        }
      }
    }
  })
})('<div class="package-review-screen-outer-div"> <!-- Modal --> <div id="reviewModel" ref ="model" class="modal hide fade in" tabindex="-1" role="dialog" aria-label="review your package information" aria-hidden="true" style="display:block"> <p v-if="dynamicRestErrorMessage" v-html="dynamicRestErrorMessage" style="margin:auto;margin-top:20px !important;" class="error alert-error"></p> <div class="modal-body"> <div class="package-review-screen"> <div class="package-review-screen-header"> <span class="success-message">{{localStrings.stepper.body.review.successLabel}}</span> <span class="booking-content">{{reservationLabel+ bookedServiceName + " for"}}</span> </div> <div v-show="bookedPackage" class="package-review-screen-package-date"> <p>{{username.split(\'-\')[0]}}</p> <span v-if="detectedChanges.time">{{ \' on \'+bookings[0].bookingDate}}</span> </div> <div v-if="bookedPackage"> <div class="package-review-screen-booking" v-for="(booking,key) in bookings" :key="key"><p class="package-review-screen-name">{{booking.itemName}} <span v-if="ReviewScreenBookingDetails.isEditingService && !detectedChanges.time">{{localStrings.stepper.body.review.updatedLabel}}</span></p> <p v-if="detectedChanges.time" class="package-review-screen-package-time"><label>{{localStrings.stepper.body.review.timeLabel}}: </label><span>{{booking.bookingTime}}</span></p></div> </div> <div v-else> <div class="package-review-screen-booking" v-for="(booking,key) in bookings" :key="key"><p class="package-review-screen-name">{{booking.username.split(\'-\')[0]}}</p> <p v-if="detectedChanges.time" class="package-review-screen-date">{{\' on \'+ booking.bookingDate}}</p></div> </div> <div class="package-review-screen-buttons-outer-div"> <button v-show="dynamicRestErrorMessage.length" class="btn btn-primary package-review-screen-bookmore-btn" @click="bookmore"> <span class="package-review-screen-bookmore-btn-span-1">{{localStrings.stepper.body.review.bookAnotherService}} {{locationName}}</span> <span class="package-review-screen-bookmore-btn-span-2"><i v-if="!desktopMode" class="fas fa-chevron-circle-right"></i></span> </button> <a v-bind:class="{ \'disabled\' : dynamicRestErrorMessage.length}" class="btn btn-primary package-review-screen-review-btn focus-first" @click="dispatchToSummary"> <span class="package-review-screen-review-btn-span-1">{{localStrings.stepper.body.review.reviewCheckOut}}</span> <span class="package-review-screen-review-btn-span-2"><i v-if="!desktopMode" class="fas fa-chevron-circle-right"></i></span> </a> </div> <div class="package-review-screen-more-activity"> <p>{{localStrings.stepper.body.review.addMoreService}}</p> <div class="package-review-screen-more-activity-inner-div"> <a v-show="serviceInfo.isEnabled" :href="serviceInfo.url" class="btn btn primary" v-for="(serviceInfo,service,index) in addMoreServices" :key="index">{{service}}</a> </div> </div> </div> </div> </div> </div>');
